/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../components/pageTitle/PageTitle";
import { useNavigate, useParams } from "react-router";
import {
  deleteUsers,
  saveOrUpdateUserData,
} from "../../services/apiservices/users";
import {
  getEmployee,
  updateUserPassword,
} from "../../services/apiservices/employee";
import CommonContext from "../../hooks/commonContext";
import { Input } from "../../components/ui/input";
import { Card, CardContent } from "../../components/ui/card";
import confirm from "../../components/DialogComponent/confirm";
import { generateP } from "../../services/helpers";
import styles from "./users.module.scss";
import { Button } from "../../components/ui/button";
import { forgotPasswordUser, ResendCMSLink } from "../../services/firebase";
import { useToast } from "../../hooks/useToast";
import AuthContext from "../../hooks/authContext";
import { useMediaQuery } from "@mui/material";
import { KeyRound, RotateCcw, Trash2 } from "lucide-react";

const CreateSuperUser = () => {
  const commonContext = useContext(CommonContext);
  const [formData, setFormData] = useState({});
  const [error, setError] = useState({});
  const [editData, setEditData] = useState(null);
  const navigate = useNavigate();
  const { superUserId } = useParams();
  const isMobile = useMediaQuery("(max-width:767px)");
  const { toast } = useToast();
  const auth = useContext(AuthContext);

  const getUserDetails = async () => {
    await getEmployee(superUserId, (res) => {
      if (res) {
        setEditData(res?.data);
        setFormData({
          firstName: res.data.firstName,
          lastName: res.data.lastName,
          email: res.data.email,
          phoneNumber: res.data.phoneNumber,
        });
      } else {
        setFormData({});
      }
    });
  };

  useEffect(() => {
    getUserDetails();
  }, [superUserId]);

  const handleInputChange = (event) => {
    const {
      target: { name, value },
    } = event;

    setFormData({ ...formData, [name]: value });

    if (error[name]) {
      setError({ ...error, [name]: "" });
    }
  };

  const validFields = () => {
    const { firstName, lastName, email } = formData;

    let errormessages = {};
    let isValid = true;

    if (!firstName || firstName.trim() === "") {
      isValid = false;
      errormessages.firstName = "First Name is Required";
    }
    if (!lastName || lastName.trim() === "") {
      isValid = false;
      errormessages.lastName = "Last Name is Required";
    }
    if (!email || email.trim() === "") {
      isValid = false;
      errormessages.email = "Email is Required";
    }
    setError(errormessages);
    return isValid;
  };

  const handelSaveData = async () => {
    commonContext?.setLoader(true);
    if (!validFields()) {
      commonContext?.setLoader(false);
      return;
    }
    const password = generateP();
    const data = {
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      email: formData?.email,
      phoneNumber: formData?.phoneNumber,
      password: password,
      confirmPassword: password,
      role: "superUser",
    };
    const newData = await saveOrUpdateUserData(data);
    if (newData?.status === true) {
      commonContext?.setLoader(false);
      setFormData({});
      navigate("/superUser");
    }
    commonContext?.setLoader(false);
  };

  const handelUpdateData = async () => {
    commonContext?.setLoader(true);
    if (!validFields()) {
      commonContext?.setLoader(false);
      return;
    }
    const data = {
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      email: formData?.email,
      phoneNumber: formData?.phoneNumber,
    };

    const newData = await saveOrUpdateUserData(data, superUserId);

    if (newData?.status === true) {
      commonContext?.setLoader(false);
      setFormData({});
      navigate("/superUser");
    }
    commonContext?.setLoader(false);
  };

  const handelCancelData = () => {
    if (superUserId) {
      navigate("/superUser");
    } else {
      setFormData({});
    }
  };

  const rundeleteSuperUser = async () => {
    try {
      commonContext?.setLoader(true);
      const res = await deleteUsers(superUserId);
      if (res?.status === true) {
        commonContext?.setLoader(false);
        setFormData({});
        confirm("SuperUser is Deleted Successfully", { cancel: false }).then(
          () => {
            navigate("/superUser");
          }
        );
      } else {
        commonContext?.setLoader(false);
        console.error("Failed to delete superUser:", res?.error);
      }
    } catch (error) {
      commonContext?.setLoader(false);
      console.error(
        "Unexpected error while deleting superUser:",
        error.message || error
      );
    }
  };

  const onDeleteSuperUser = async () => {
    await confirm("Are you Sure you want to Remove this SuperUser?").then(
      () => {
        rundeleteSuperUser();
      },
      console.log("delete!")
    );
  };

  const ResetPasswordLink = async () => {
    commonContext?.setLoader(true);
    const { email } = formData;
    await forgotPasswordUser(
      email,
      () => {
        commonContext?.setLoader(false);
        toast({
          title: "Success",
          description: "Reset Password Link sent to User's Email...",
        });
      },
      (error) => {
        commonContext?.setLoader(false);
        console.error("Error resetting password:", error);
        toast({
          title: "Error",
          description: error?.message || "An error occurred. Please try again.",
          variant: "destructive",
        });
      }
    );
  };

  const ResendinvitaLink = async () => {
    commonContext?.setLoader(true);
    const { firstName, email, phoneNumber } = formData;
    const password = generateP();
    try {
      await updateUserPassword(editData?.userId, {
        password: password,
        email: email,
      });

      Promise.allSettled([
        ResendCMSLink(email, phoneNumber, firstName, password),
      ]).then((results) => {
        console.log("Background invite results:", results);
      });

      commonContext?.setLoader(false);
      // alert("Resend Invitation sent to Employee");
      toast({ title: "Success", description: "Resend Invitation sent to superUser" });
    } catch (error) {
      commonContext?.setLoader(false);
      console.error("Error sending invitation link:", error);
      // alert("An error occurred. Please try again.");
      toast({ title: "Error", description: "An error occurred. Please try again.", variant: "destructive" });
    }
  };

  const onResetPassword = async () => {
    await confirm(
      "Are you Sure you want to Send Reset Password Link to this superUser?"
    ).then(
      () => {
        ResetPasswordLink();
      },
      () => {
        console.log("cancel!");
      }
    );
  };

  const onResendinvitation = async () => {
    await confirm(
      "Are you Sure you want to Resend invitation to this superUser?"
    ).then(
      () => {
        ResendinvitaLink();
      },
      () => {
        console.log("cancel!");
      }
    );
  };

  return (
    <Container>
      <PageTitle
        pageTitle={"Create SuperUser"}
        showBreadcrumb={[
          { label: "Home", to: "/" },
          { label: "SuperUser", to: "/superUser" },
        ]}
        BreadCrumbCurrentPageTitle={"Create SuperUser"}
        showLastSeen={true}
      />

      <div className={`${styles.tabs}`}>
        {typeof superUserId !== "undefined" && superUserId !== "" && (
          <div
            className={
              isMobile
                ? "d-flex flex-direction-column"
                : "d-flex flex-center flex-space-between"
            }
          >
            <div className={isMobile ? "mv-10 mh-10" : "mv-30"}>
              <h1 className="text-xl md:text-2xl font-bold tracking-tight dark:text-white">
                Edit{" "}
                {`${
                  editData?.firstName
                    ? `${editData?.firstName} ${editData?.lastName}`
                    : "SuperUser x"
                }`}
              </h1>
            </div>
            <div className={isMobile ? "d-flex flex-direction-column" : ""}>
              <Button
                variant="outlined"
                className={isMobile ? "mv-10 mh-10" : "mr-12 mv-30"}
                style={{
                  backgroundColor: "#FEF2F2",
                  color: "#DC2626",
                  border: "1px solid rgba(254, 202, 202, 1)",
                  padding: "8px 16px",
                }}
                onClick={onDeleteSuperUser}
              >
                <Trash2 className="h-4 w-4 mr-8" />
                Delete User
              </Button>
              <Button
                variant="outlined"
                className={isMobile ? "mv-10  mh-10" : "mr-12 mv-30"}
                style={{
                  backgroundColor: "#FEF2F2",
                  color: "#DC2626",
                  border: "1px solid rgba(254, 202, 202, 1)",
                  padding: "8px 16px",
                }}
                onClick={onResetPassword}
              >
                <KeyRound className="w-4 h-4 mr-8" />
                Reset password
              </Button>
              <Button
                variant="outlined"
                className={isMobile ? "mv-10  mh-10" : "mr-12 mv-30"}
                style={{
                  backgroundColor: "#FEF2F2",
                  color: "#DC2626",
                  border: "1px solid rgba(254, 202, 202, 1)",
                  padding: "8px 16px",
                }}
                onClick={onResendinvitation}
              >
                <RotateCcw className="h-4 w-4 mr-8" />
                Resend Invitation
              </Button>
            </div>
          </div>
        )}
        <Card
          className={`${styles.cardProfile} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
        >
          <CardContent className="p-24">
            <div className="stepSectionContent">
              <div className="formFieldwrap mv-20">
                <Typography
                  variant="body"
                  className={`${styles.labelSm} dark:text-white`}
                >
                  First Name
                </Typography>
                <div className="w-100 mt-8">
                  <Input
                    name="firstName"
                    id="firstName"
                    label="First Name *"
                    variant="outlined"
                    placeholder="First Name"
                    onChange={handleInputChange}
                    value={formData?.firstName ? formData?.firstName : ""}
                  />
                  {typeof error?.firstName !== "undefined" &&
                    error?.firstName !== "" && (
                      <span className="d-flex small error color-danger">
                        {error?.firstName}
                      </span>
                    )}
                </div>
              </div>
              <div className="formFieldwrap mv-20">
                <Typography
                  variant="body"
                  className={`${styles.labelSm} dark:text-white`}
                >
                  Last Name
                </Typography>
                <div className="w-100 mt-8">
                  <Input
                    name="lastName"
                    id="lastName"
                    label="Last Name *"
                    variant="outlined"
                    placeholder="Last Name"
                    onChange={handleInputChange}
                    value={formData?.lastName ? formData?.lastName : ""}
                  />
                  {typeof error?.lastName !== "undefined" &&
                    error?.lastName !== "" && (
                      <span className="d-flex small error color-danger">
                        {error?.lastName}
                      </span>
                    )}
                </div>
              </div>
              <div className="formFieldwrap mv-20">
                <Typography
                  variant="body"
                  className={`${styles.labelSm} dark:text-white`}
                >
                  Email
                </Typography>
                <div className="w-100 mt-8">
                  <Input
                    name="email"
                    id="email"
                    label="Email *"
                    variant="outlined"
                    placeholder="Email"
                    onChange={handleInputChange}
                    value={formData?.email ? formData?.email : ""}
                  />
                  {typeof error?.email !== "undefined" &&
                    error?.email !== "" && (
                      <span className="d-flex small error color-danger">
                        {error?.email}
                      </span>
                    )}
                </div>
              </div>

              <div className="formFieldwrap mv-20">
                <Typography
                  variant="body"
                  className={`${styles.labelSm} dark:text-white`}
                >
                  Mobile
                </Typography>
                <div className="w-100 mt-8">
                  <Input
                    name="phoneNumber"
                    id="phoneNumber"
                    label="Phone Number"
                    variant="outlined"
                    placeholder="Phone Number"
                    onChange={handleInputChange}
                    value={formData?.phoneNumber ? formData?.phoneNumber : ""}
                  />
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
        <div className="mv-15 d-flex flex-center flex-space-between">
          <Button variant="outline" onClick={handelCancelData}>
            Cancel
          </Button>
          <Button
            variant={"contained"}
            className="bg-green-600 hover:bg-green-700 color-white"
            onClick={superUserId ? handelUpdateData : handelSaveData}
          >
            {superUserId ? "Update" : "Save"}
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default CreateSuperUser;
